import { branch } from '../constants'

module.exports = (transaction) ->
  try
    await Weaver.Branch.createBranch(branch)
  catch
    console.warn '$config branch exists, skipping...'